import { AirConditioningType } from '../domain/types';

export const airConditioningTypeLabels: Record<AirConditioningType, string> = {
  [AirConditioningType.AUTONOMO]: 'Autonomo',
  [AirConditioningType.CENTRALIZZATO]: 'Centralizzato',
  [AirConditioningType.PREDISPOSIZIONE]: 'Predisposizione',
  [AirConditioningType.ASSENTE]: 'Assente',
};
